import { useWatch } from "react-hook-form";
import Scheduler from "../../../components/scheduler/Scheduler";
import { FormWizardStepProps } from "../../../models/form-wizard-step-props";
import { SubstituteSchedulerLesson } from "../../../components/scheduler/SubstituteScheduler";
import { ViewModeWeek } from "../../../components/ui-lib/scheduler/viewModeWeek";
import { Schedule } from "../../../models/schedule/schedule";
import { resetSelectedSubstitutesAdapter } from "../../../components/scheduler/substitue-scheduler-lesson-modifier";
import { VacancyFormFields } from "../VacancyCreateWizard";
import { useMemo } from "react";

function LessonsStep({
  control,
  setLessons: setLessonsExternal,
  schedule,
  lessons,
}: FormWizardStepProps<VacancyFormFields> & {
  setLessons: (lessons: SubstituteSchedulerLesson[][]) => void;
  schedule: Schedule;
  lessons: SubstituteSchedulerLesson[][];
}) {
  const dateStrings = useWatch({ name: ["start", "end"], control });
  const dates = useMemo(
    () => dateStrings.map((date) => new Date(date)),
    [dateStrings],
  );

  const onSetLessons = (lessons: SubstituteSchedulerLesson[][]) => {
    setLessonsExternal(lessons);
  };

  return (
    <div className="flex h-full w-full items-center justify-center">
      <div className="flex-grow space-y-4">
        <h2
          className="text-center text-th-primary-900"
          data-cy="wizard-step-title"
        >
          Betroffene Lektionen des Ausfalles
        </h2>
        <p className="text-center">Lektionen, die nicht vom Ausfall betroffen sind können per Klick vom Ausfall entfernt werden.</p>
        <Scheduler
          className="m-auto md:max-w-[75%] xl:max-w-[50%]"
          lessons={lessons}
          startDate={dates[0]}
          duration={schedule?.duration}
          viewMode={new ViewModeWeek(false)}
          // Need to reset the selected substitute if a lesson changes here
          // Otherwise a substitute can still be active on an inactive lesson
          setValue={resetSelectedSubstitutesAdapter(onSetLessons)}
        />
      </div>
    </div>
  );
}

export default LessonsStep;
